import { Rutas } from '@/constants/rutas';

export const NavigationEditorItems = [
    {
        title: 'Parte médico',
        shortTitle: 'Lesiones',
        path: Rutas.PARTE_MEDICO,
    },
    {
        title: 'Alineaciones probables',
        shortTitle: 'Alineaciones',
        path: Rutas.ALINEACIONES_PROBABLES_EDITORES,
    },
    {
        title: 'Alineaciones confirmadas',
        shortTitle: 'Convocatorias',
        path: Rutas.ADMINISTRADOR_CONVOCATORIAS,
    },
    {
        title: 'Calendario administrador',
        shortTitle: 'Calendario',
        path: Rutas.CALENDARIO_ADMIN,
    },
    {
        title: 'Análisis de partidos',
        shortTitle: 'Análisis',
        path: Rutas.ADMINISTRADOR_ANALISIS_PARTIDO,
    },
    {
        title: 'Previa de partidos',
        shortTitle: 'Previa',
        path: Rutas.EDITORES_PREVIA_PARTIDO,
    },
    {
        title: 'Comentarios',
        shortTitle: 'Comentarios',
        path: Rutas.EDITORES_COMENTARIOS,
    },
    {
        title: 'Top Star',
        shortTitle: 'Top Star',
        path: Rutas.EDITORES_TOP_STAR,
    },
];
